import { fetchFactory } from 'isotope-client'
import { getFormattedUrl } from '../../../../utils/fetchDownload'
import { RequestStockFiltersModel } from '../../../admin/stock/services/stockModel'

export const getStockByProduit = (prefixUrl: string, idProduit: string) => fetchFactory(`/${prefixUrl}/preparation?idProduit=${idProduit}`)

export const getStockPageMobile = (url: string, filters: RequestStockFiltersModel, page: number) => fetchFactory(`${getFormattedUrl(url, filters)}&page=${page}&size=5`)
